<div class="settings-container">
    <app-gradient class="gradient gradient__left"></app-gradient>
    <app-gradient class="gradient gradient__right"></app-gradient>
    <div class="settings-container__header">
      <div class="settings-container__header_content">
        <div class="settings-container__header_data">
          <h1 class="heading-s">Settings</h1>
          <h3 class="body-m text-dark-alt">Manage your local options</h3>
        </div>
      </div>
      <div class="settings-tab-nav">
        <a
          class="settings-tab body-m"
          [class.active]="activeTab === 'settings'"
          (click)="selectTab('settings')"
            >
          General settings
        </a>
        <a
          class="settings-tab body-m"
          [class.active]="activeTab === 'need-captures'"
          (click)="selectTab('need-captures')"
           >
          Need Capture
        </a>
      </div>
    </div>
      <div class="settings-tab-content">
        @if(activeTab === 'settings') {
            <ng-container>
              <span class="body-m">Settings content...</span>
            </ng-container>
        }
        @else if(activeTab === 'need-captures') {
            <ng-container>
                <app-admin-need-capture-settings></app-admin-need-capture-settings>
            </ng-container>
        }
      </div>
</div>